import { connect } from "react-redux";
import { Navigate, Outlet, useLocation } from 'react-router';
import { ReduxState } from "types";
import { FC } from "react";


export const ProtectedRoutes: FC<Props> = ({ token, onboardedOn }) => {
    const location = useLocation();

    if (!token) {
        return <Navigate to="/login" />
    }

    if (!onboardedOn && location?.pathname !== '/onboarding') {
        return <Navigate to='/onboarding' />
    }

    return <Outlet />
};


type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;


function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth.token,
        onboardedOn: state.companyDetails?.companyDetails?.onboardedOn,
    };
}

export default connect(mapStateToProps)(ProtectedRoutes);